import Vue from 'vue';
import VueRouter from 'vue-router';
import DataList from '../views/DataList.vue';
import AnnotationList from '../views/AnnotationList.vue';
import LogList from '../views/LogList.vue';
import NodeStudioDownload from '../views/NodeStudioDownload.vue';
import GpuMonitor from '../views/blissrose/GpuMonitor.vue';
import ModelInstances from '../views/blissrose/ModelInstances.vue';
import BlissroseDatasets from '../views/blissrose/Datasets.vue';
import VideoStream from '../views/blissrose/VideoStream.vue';
import TrainingMonitor from '../views/blissrose/TrainingMonitor.vue';
import EvaluationMonitor from '../views/blissrose/EvaluationMonitor.vue';

Vue.use(VueRouter);

// 登录态由 main.js 在挂载前确认；路由不做拦截
const routes = [
  {
    path: '/',
    redirect: '/data',
  },
  {
    path: '/data',
    name: 'DataList',
    component: DataList,
    meta: { title: '数据列表' },
  },
  {
    path: '/annotation',
    name: 'AnnotationList',
    component: AnnotationList,
    meta: { title: '场景识别' },
  },
  {
    path: '/logs',
    name: 'LogList',
    component: LogList,
    meta: { title: '日志管理' },
  },
  {
    path: '/download/node-studio',
    name: 'NodeStudioDownload',
    component: NodeStudioDownload,
    meta: { title: 'Node Studio 下载' },
  },
  {
    path: '/blissrose/models',
    name: 'ModelInstances',
    component: ModelInstances,
    meta: { title: '模型实例' },
  },
  {
    path: '/blissrose/datasets',
    name: 'BlissroseDatasets',
    component: BlissroseDatasets,
    meta: { title: '数据集' },
  },
  {
    path: '/blissrose/training',
    name: 'BlissroseTraining',
    component: TrainingMonitor,
    meta: { title: '训练监控' },
  },
  {
    path: '/blissrose/evaluation',
    name: 'BlissroseEvaluation',
    component: EvaluationMonitor,
    meta: { title: '模型评估' },
  },
  {
    // 推理实例已并入模型实例页，旧链（含带 model_id 的跳转）照旧可用
    path: '/blissrose/inference',
    redirect: to => ({ path: '/blissrose/models', query: to.query }),
  },
  {
    path: '/blissrose/gpu',
    name: 'GpuMonitor',
    component: GpuMonitor,
    meta: { title: 'GPU 监控' },
  },
  {
    path: '/blissrose/video',
    name: 'VideoStream',
    component: VideoStream,
    meta: { title: '视频推理' },
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

export default router;
